import { colors } from '../../../../../../../../../colorVars';
import { Body3 } from '../../../../../../../../../components/atomic/text/Text';

export function orderModificationOutsideOfTradePlanBuilder({parsedStatusObj}) {
  return (
    <td>
      <Body3 fontWeight={500} color={colors.lightGrey}>
        Order modification outside of trade plan.
        {parsedStatusObj.symbol ? '[' + parsedStatusObj.symbol + ']' : ''}
      </Body3>
    </td>
  );
}
